const odoMeter = document.querySelector('.odometer');

if (document.body.contains(odoMeter)) {
    // Get the an HTML element
    const odoMeter1 = document
        .getElementById('odometer1')
        .getAttribute('data-number');
    const odoMeter2 = document
        .getElementById('odometer2')
        .getAttribute('data-number');
    const odoMeter3 = document
        .getElementById('odometer3')
        .getAttribute('data-number');
    var aboutNumber = document.querySelector('.highlight__item');

    // Get its bounding client rectangle
    var bounding = aboutNumber.getBoundingClientRect();

    function isInViewport(element) {
        // Get the bounding client rectangle position in the viewport
        var bounding = element.getBoundingClientRect();

        // Checking part. Here the code checks if it's *fully* visible
        // Edit this part if you just want a partial visibility
        if (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.right <=
                (window.innerWidth || document.documentElement.clientWidth) &&
            bounding.bottom <=
                (window.innerHeight || document.documentElement.clientHeight)
        ) {
            // console.log('In the viewport! :)');
            return true;
        } else {
            // console.log('Not in the viewport. :(');
            return false;
        }
    }

    window.addEventListener(
        'scroll',
        function (event) {
            if (isInViewport(aboutNumber)) {
                // update the element display
                setTimeout(function () {
                    odometer1.innerHTML = odoMeter1;
                }, 1000);

                setTimeout(function () {
                    odometer2.innerHTML = odoMeter2;
                }, 1000);

                setTimeout(function () {
                    odometer3.innerHTML = odoMeter3;
                }, 1000);
            } else {
                setTimeout(function () {
                    odometer1.innerHTML = 0;
                }, 1000);

                setTimeout(function () {
                    odometer2.innerHTML = 0;
                }, 1000);

                setTimeout(function () {
                    odometer3.innerHTML = 0;
                }, 1000);
            }
        },
        false
    );
}
